"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var automation_attribute_1 = __importDefault(require("../../_helpers/automation-attribute"));
var pagination_1 = require("../../_helpers/pagination");
var button_1 = __importDefault(require("../../atoms/button"));
var icon_1 = __importDefault(require("../../atoms/icon"));
var text_input_1 = __importDefault(require("../../atoms/text-input"));
var button_group_1 = __importDefault(require("../../molecules/button-group"));
var styled_1 = __importDefault(require("../../styled"));
var tokens_1 = require("../../tokens");
var Pager = function (_a) {
    var page = _a.page, pages = _a.pages, onPrevPressed = _a.onPrevPressed, onNextPressed = _a.onNextPressed;
    var inFirstPage = page === 1;
    var inLastPage = page === pages;
    return (React.createElement(button_group_1.default, { compressed: true },
        React.createElement(Pager.Button, { icon: "chevron-left", size: "compressed", onClick: onPrevPressed, disabled: inFirstPage, "aria-label": "Previous page" }),
        React.createElement(Pager.Button, { icon: "chevron-right", size: "compressed", onClick: onNextPressed, disabled: inLastPage, "aria-label": "Next page" })));
};
Pager.Button = styled_1.default(button_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", " {\n    path {\n      fill: ", ";\n    }\n  }\n"], ["\n  ", " {\n    path {\n      fill: ", ";\n    }\n  }\n"])), icon_1.default.Element, tokens_1.colors.text.inputs);
var PaginationToolbar = function (_a) {
    var onPageChanged = _a.onPageChanged, page = _a.page, perPage = _a.perPage, items = _a.items, props = __rest(_a, ["onPageChanged", "page", "perPage", "items"]);
    var pages = pagination_1.pagesFromItems(items, perPage);
    if (pages <= 1) {
        return null;
    }
    return (React.createElement(PaginationToolbar.Element, __assign({}, automation_attribute_1.default('pagination-toolbar'), props),
        React.createElement(PaginationToolbar.PageSelector, { page: page },
            React.createElement("div", null, "Page"),
            React.createElement(text_input_1.default, { type: "number", size: "compressed", value: page.toString(), onChange: function (_a) {
                    var value = _a.target.value;
                    return pagination_1.changePageIfAppropiate({ rawNextPage: value, total: items, perPage: perPage, onPageChanged: onPageChanged });
                } }),
            React.createElement("div", null,
                "of ",
                pages)),
        React.createElement(Pager, { page: page, pages: pages, onNextPressed: function () {
                return pagination_1.changePageIfAppropiate({ rawNextPage: page + 1, total: items, perPage: perPage, onPageChanged: onPageChanged });
            }, onPrevPressed: function () {
                return pagination_1.changePageIfAppropiate({ rawNextPage: page - 1, total: items, perPage: perPage, onPageChanged: onPageChanged });
            } })));
};
PaginationToolbar.Element = styled_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin-top: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin-top: ", ";\n"])), tokens_1.spacing.medium);
PaginationToolbar.PageSelector = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  & > * {\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  ", " {\n    width: ", "px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  & > * {\n    margin-right: ", ";\n    &:last-child {\n      margin-right: 0;\n    }\n  }\n\n  ", " {\n    width: ", "px;\n  }\n"])), tokens_1.spacing.xsmall, text_input_1.default.Element, function (_a) {
    var page = _a.page;
    return pagination_1.pageInputWidth(page);
});
exports.default = PaginationToolbar;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=pagination-toolbar.js.map